//当前选择的楼房
export default {
    namespaced: true,
    state: {
        house: {
        }
    },
    getters: {
        //返回
        getHouse(state) {
            return state.house;
        }
    },
    mutations: {
        //该方法，用于对user对象复制
        setHouse(state, val) {
            state.house = val;
        },
        //清空user
        clearHouse() {
            state.house.value = null;
        }
    }
}